import * as React from 'react';
export const StarGrayIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={32}
    viewBox="0 0 33 32"
    fill="none"
    {...props}
  >
    <path
      fill="#E0E2EE"
      d="m29.786 14.356-5.625 4.853 1.714 7.26a2.05 2.05 0 0 1-3.063 2.227L16.5 24.81l-6.316 3.885a2.05 2.05 0 0 1-3.06-2.228l1.72-7.259-5.624-4.853a2.058 2.058 0 0 1 1.165-3.606l7.375-.595 2.845-6.885a2.045 2.045 0 0 1 3.784 0l2.843 6.885 7.375.595a2.057 2.057 0 0 1 1.172 3.607l.007-.001Z"
    />
    <path
      fill="url(#a)"
      fillOpacity={0.5}
      d="m29.786 14.356-5.625 4.853 1.714 7.26a2.05 2.05 0 0 1-3.063 2.227L16.5 24.81l-6.316 3.885a2.05 2.05 0 0 1-3.06-2.228l1.72-7.259-5.624-4.853a2.058 2.058 0 0 1 1.165-3.606l7.375-.595 2.845-6.885a2.045 2.045 0 0 1 3.784 0l2.843 6.885 7.375.595a2.057 2.057 0 0 1 1.172 3.607l.007-.001Z"
      style={{
        mixBlendMode: 'overlay',
      }}
    />
    <defs>
      <linearGradient
        id="a"
        x1={16.5}
        x2={16.5}
        y1={2.001}
        y2={28.997}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0} />
        <stop offset={1} />
      </linearGradient>
    </defs>
  </svg>
);
